module.exports = __webpack_public_path__ + "static/media/folder-orange.9620421c.svg";